<section class="border border-red-200 rounded-2xl bg-white shadow-sm overflow-hidden">
  <div class="flex flex-wrap items-center justify-between gap-3 px-5 py-4 bg-red-50">
    <div>
      <h2 class="font-semibold text-lg text-red-900">Errores de carga de {{ entityLabel }}</h2>
      <p class="text-sm text-red-700">{{ totalErrors }} error(es) encontrados</p>
    </div>
  </div>

  <div class="overflow-auto max-h-[28rem]">
    <table class="w-full min-w-[42rem] text-sm">
      <thead class="sticky top-0 bg-gray-100 text-left">
        <tr>
          <th class="px-4 py-3 font-semibold">Tipo</th>
          <th class="px-4 py-3 font-semibold">Fila</th>
          <th class="px-4 py-3 font-semibold">Código / llave</th>
          <th class="px-4 py-3 font-semibold">Campo</th>
          <th class="px-4 py-3 font-semibold">Detalle</th>
        </tr>
      </thead>
      <tbody>
        @for (error of visibleErrors; track $index) {
          <tr class="border-t border-gray-100 align-top hover:bg-red-50">
            <td class="px-4 py-3 whitespace-nowrap">{{ error.entityType }}</td>
            <td class="px-4 py-3 whitespace-nowrap">{{ error.rowNumber }}</td>
            <td class="px-4 py-3">{{ error.identifier || '—' }}</td>
            <td class="px-4 py-3">{{ error.field || '—' }}</td>
            <td class="px-4 py-3 whitespace-pre-wrap">{{ error.message }}</td>
          </tr>
        } @empty {
          <tr>
            <td colspan="5" class="px-4 py-6 text-center text-gray-500">No hay errores para mostrar.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <mat-paginator
    class="massive-load-errors-paginator"
    [length]="errors.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="[25, 50, 100]"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)">
  </mat-paginator>
</section>
